import React from 'react';
import { Form, Space } from 'antd';
import InfoIcon from '@severalnines/bar-frontend-components/build/lib/General/InfoIcon';
import { FormItemProps } from 'antd/lib/form';
import ConfigTemplateInput from '../../DataEntry/ConfigTemplateInput';
import { CcClusterType } from '../../../services/models/CcCluster';

export default MongoNodeConfigurationTemplateField;

export type ConfigurationTemplateProps = FormItemProps & {
    vendor: string;
    version: string;
    required?: boolean;
    clusterType: CcClusterType;
};

function MongoNodeConfigurationTemplateField({
    name = 'routerConfigurationTemplate',
    vendor,
    version,
    required = false,
    clusterType,
    ...rest
}: ConfigurationTemplateProps) {
    return (
        <div className="MongoNodeConfigurationTemplateField">
            <Form.Item
                name={name}
                label={
                    <Space>
                        Router Configuration template
                        <InfoIcon info="The configuration template for mongo routers." />
                    </Space>
                }
                {...rest}
                rules={[
                    {
                        required,
                        message: 'Please choose configuration template',
                    },
                ]}
            >
                <ConfigTemplateInput
                    clusterType={clusterType}
                    vendor={vendor}
                    version={version}
                    extraQueryParams={{ db_role: 'mongos' }}
                />
            </Form.Item>
        </div>
    );
}
